import { CONFIG_NAME } from "./configs/enums";
import { PROFILE_ENVIRONMENT } from "./profiles/enums";
import { findConfigByName } from "./configs";
import { findProfile } from "./profiles";
import * as merge from "lodash.merge";
import base from "./configs/base";

export const buildConfig = (
  name: CONFIG_NAME,
  environment: PROFILE_ENVIRONMENT
) => {
  const config = findConfigByName(name);
  const profile = findProfile(config.profileId, environment);

  return merge(
    {},
    {
      sdkIntegration: base.sdkIntegration,
      sdkConfig: base.sdkConfig,
      appConfig: base.appConfig,
    },
    { sdkConfig: config.sdkConfig, appConfig: config.appConfig },
    {
      sdkConfig: {
        chatbotId: profile.chatbotId,
        environment,
      },
    },
    {
      sdkAuth: { inbentaKey: profile.inbentaKey, domainKey: profile.domainKey },
    }
  );
};
